import { z } from 'zod';
import { uuidSchema } from './common';

export const userStatusSchema = z.enum(['active', 'suspended', 'pending']);
export const kycStatusSchema = z.enum(['none', 'submitted', 'verified', 'rejected']);

export const updateUserSchema = z.object({
  firstName: z.string().min(1).max(100).optional(),
  middleName: z.string().max(100).optional().nullable(),
  lastName: z.string().min(1).max(100).optional(),
  phone: z.string().optional().nullable(),
  status: userStatusSchema.optional(),
});

export const assignRolesSchema = z.object({
  roleIds: z.array(uuidSchema).min(1),
  scopeBranchId: uuidSchema.nullable().optional(),
});

export const kycSubmissionSchema = z.object({
  documents: z.array(z.object({ kind: z.string(), r2Key: z.string() })).min(1),
});

export const kycReviewSchema = z.object({
  decision: z.enum(['verified', 'rejected']),
  rejectionReason: z.string().optional(),
});
